import styled from "styled-components";
import { fadeIn } from "../../../components/Common/CommonStyles";

export const DashboardStyles = {
  homeButtonWidth: "auto",
  homeButtonHeight: "50px",
};

export const DashboardButtonsContainer = styled.div`
  flex: 1;
  display: flex;
  max-width: ${({ maxWidth }) => maxWidth || "950px"};
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const DisclaimerContainer = styled.div`
  flex: 1;
  flex-direction: column;
  border: 2px solid ${(props) => props.colorBorder || "black"};
  padding: 8px;
  border-radius: 12px;
  max-width: ${({ maxWidth }) => maxWidth || "950px"};
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const ModalOptionsButtonsContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  max-width: ${({ maxWidth }) => maxWidth || "950px"};
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;